import type { ToolMark } from './schema'

const mark = (name: string, file: string, mono?: true): ToolMark => ({ name, logo: `/images/tools/${file}`, mono })

/** Every tool logo the site can show. Pages reference these, never a raw path. */
export const tools = {
  ghl: mark('GoHighLevel', 'gohighlevel.png'),
  n8n: mark('n8n', 'n8n.svg'),
  zapier: mark('Zapier', 'zapier.svg'),
  openai: mark('OpenAI', 'openai.svg', true),
  claude: mark('Claude', 'claude-color.svg'),
  claudeCode: mark('Claude Code', 'claude-code-logo.webp'),
  codex: mark('Codex', 'codex.svg', true),
  cursor: mark('Cursor', 'cursor.svg', true),
  hermes: mark('Hermes AI', 'nousresearch.svg', true),
  glm: mark('GLM', 'zhipu.svg', true),
  qwen: mark('Qwen', 'qwen.svg'),
  namecheap: mark('Namecheap', 'namecheap.svg'),
  fireflies: mark('Fireflies', 'fireflies.png'),
  vscode: mark('VS Code', 'vscode.svg'),
  react: mark('React', 'react.svg'),
  tailwind: mark('Tailwind CSS', 'tailwindcss.svg'),
  vite: mark('Vite', 'vite.svg'),
  cloudflare: mark('Cloudflare', 'cloudflare.svg'),
  github: mark('GitHub', 'github.svg', true),
  expo: mark('Expo', 'expo.svg', true),
  chrome: mark('Chrome', 'googlechrome.svg'),
  workspace: mark('Google Workspace', 'googleworkspace.svg'),
  slack: mark('Slack', 'slack.svg'),
  lightspeed: mark('Lightspeed X-Series', 'lightspeed.png'),
  zendesk: mark('Zendesk', 'zendesk.svg'),
  intercom: mark('Intercom', 'intercom.svg'),
} satisfies Record<string, ToolMark>

/** The daily drivers, in the order v1 shows them. */
export const dailyTools: ToolMark[] = [
  tools.claudeCode,
  tools.codex,
  tools.cursor,
  tools.hermes,
  tools.vscode,
  tools.ghl,
  tools.lightspeed,
  tools.workspace,
  tools.zendesk,
  tools.intercom,
  tools.slack,
]
